export const globalAntTheme = {
  token: {},
};
